export const globalAntTheme = {
  token: {},
};
